import actions from './actions'
import { factoryReducer } from '../factory'

const initialState = {
  listing: [],
  loading: false,
  details: null,
  detailsLoading: false,
  addMedicalGroupStatus: null,
  editMedicalGroupStatus: null,
  assignFacilitiesToGroupStatus: null,
  redirect: null,
}

export default factoryReducer(initialState, actions)
